import { CCourseFormats } from "./CCourseFormats";
export const CCourseFormatsOptions = {
  [CCourseFormats.IN_PERSON]: "In person classes",
  [CCourseFormats.ONLINE]: "Online classes"
};
